// extracted by mini-css-extract-plugin
export default {"wrap":"follow-us_wrap__uMI4q","item":"follow-us_item__lN7cc"};